<template>
  <loan-status-alert-container :loan="loan">
    <template #borrower>
      <i18n path="components.loan.status.alerts.confirmed.borrower.location_instructions" tag="p">
        <template #vehicle_details>
          <icon-button
            variant="ghost-secondary"
            size="inline"
            @click="$emit('jump', sections.instructions)"
          >
            {{ $t("components.loan.status.alerts.confirmed.borrower.vehicle_details") }}
          </icon-button>
        </template>
        <template #owner_name>{{ loanableOwnerUser.name }}</template>
      </i18n>

      <i18n
        v-if="loan.borrower_may_contribute && !loan.platform_tip"
        path="components.loan.status.alerts.confirmed.borrower.contribution_message"
        tag="p"
      >
        <template #contribute>
          <icon-button
            variant="ghost-secondary"
            size="inline"
            @click="$emit('jump', sections.contribution)"
            >{{ $t("components.loan.status.alerts.confirmed.borrower.contribute") }}</icon-button
          >
        </template>
      </i18n>

      <template v-if="loan.loanable.type === 'car'">
        <div class="font-weight-bold">
          {{ $t("components.loan.status.alerts.confirmed.start_title") }}
        </div>
        <ol class="mb-0">
          <li>
            <i18n
              v-if="loan.loanable.details.report"
              path="components.loan.status.alerts.confirmed.borrower.check_condition_with_report"
              tag="span"
            >
              <template #condition_report>
                <safe-file :file="loan.loanable.details.report">{{
                  $t("components.loan.status.alerts.confirmed.condition_report")
                }}</safe-file></template
              >
            </i18n>
            <span v-else>{{
              $t("components.loan.status.alerts.confirmed.borrower.check_condition")
            }}</span>
          </li>
          <template v-if="loan.requires_detailed_mileage">
            <li>
              <i18n path="components.loan.status.alerts.confirmed.enter_mileage_message">
                <template #enter_mileage
                  ><icon-button
                    variant="ghost-secondary"
                    size="inline"
                    @click="$emit('jump', sections.info)"
                    >{{ $t("components.loan.status.alerts.confirmed.enter_mileage") }}</icon-button
                  ></template
                >
              </i18n>
            </li>
            <li>
              {{ $t("components.loan.status.alerts.confirmed.add_photo") }}
            </li>
          </template>
        </ol>
      </template>
    </template>
    <template #owner>
      <template v-if="loan.loanable.type === 'car'">
        <div class="font-weight-bold">
          {{ $t("components.loan.status.alerts.confirmed.start_title") }}
        </div>
        <ol class="mb-0">
          <li>
            <span v-if="loan.loanable.details.report">
              <i18n path="components.loan.status.alerts.confirmed.owner.update_condition_report">
                <template #condition_report>
                  <safe-file :file="loan.loanable.details.report">
                    {{ $t("components.loan.status.alerts.confirmed.condition_report") }}
                  </safe-file>
                </template>
                <template #condition_report_update_url>
                  <router-link :to="`/profile/loanables/${loan.loanable.id}#report-section`">
                    {{
                      $t(
                        "components.loan.status.alerts.confirmed.owner.condition_report_update_url"
                      )
                    }}</router-link
                  >
                </template>
              </i18n>
            </span>
            <template v-else>
              <i18n path="components.loan.status.alerts.confirmed.owner.add_report" tag="span">
                <template #add_report_link>
                  <router-link :to="`/profile/loanables/${loan.loanable.id}#report-section`">
                    {{ $t("components.loan.status.alerts.confirmed.owner.add_report_link") }}
                  </router-link>
                </template>
              </i18n>
            </template>
          </li>
          <template v-if="loan.requires_detailed_mileage">
            <li>
              <i18n path="components.loan.status.alerts.confirmed.enter_mileage_message">
                <template #enter_mileage
                  ><icon-button
                    variant="ghost-secondary"
                    size="inline"
                    @click="$emit('jump', sections.info)"
                    >{{ $t("components.loan.status.alerts.confirmed.enter_mileage") }}</icon-button
                  ></template
                >
              </i18n>
            </li>
            <li>
              {{ $t("components.loan.status.alerts.confirmed.add_photo") }}
            </li>
          </template>
        </ol>
      </template>
      <p v-else>{{ $t("components.loan.status.alerts.confirmed.waiting") }}</p>
    </template>

    <template #admin>
      <p>{{ $t("components.loan.status.alerts.confirmed.waiting") }}</p>
    </template>
  </loan-status-alert-container>
</template>

<script>
import LoanStatusAlertContainer from "@/components/Loan/Status/Alerts/LoanStatusAlertContainer.vue";
import IconButton from "@/components/shared/IconButton.vue";
import SafeFile from "@/components/shared/SafeFile.vue";
import { getOwner, isCoownerOrOwner } from "@/helpers/permissions/loanables";
import { isBorrower } from "@/helpers/permissions/loans";
import { sections } from "@/components/Loan/FullLoanSections";

export default {
  name: "LoanConfirmed",
  components: {
    IconButton,
    LoanStatusAlertContainer,
    SafeFile,
  },
  props: {
    loan: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      sections,
    };
  },
  computed: {
    isBorrower() {
      return isBorrower(this.$store.state.user, this.loan);
    },
    isCoownerOrOwner() {
      return isCoownerOrOwner(this.$store.state.user, this.loan.loanable);
    },
    loanableOwnerUser() {
      return getOwner(this.loan.loanable);
    },
  },
};
</script>

<style lang="scss"></style>
